import { createApp } from 'vue'
import App from './App.vue'

import naive from 'naive-ui'
import VueApexCharts from "vue3-apexcharts"

createApp(App).use(naive).use(VueApexCharts).mount('#app')
